export default __webpack_public_path__ + "static/media/SafetyNest_Purple_Positive_RGB.8ad9f8b0.svg";